import { createSlice } from "@reduxjs/toolkit";
import { getCookie, getObjectFromCookie } from "../utils/Utils";

const initialState = {
    signinData: getObjectFromCookie("userDataPremium") ? getObjectFromCookie("userDataPremium") : {},
    allUsers: [],
    allPrivilegedUsers: [],
    loading: false,
    isProd: false,
    token: getCookie('takeuforward_premium_dashboard') ? getCookie('takeuforward_premium_dashboard') : null,
};

const authSlice = createSlice({
    name: "auth",
    initialState: initialState,
    reducers: {
        setSignInData(state, value) {
            state.signinData = value.payload;
        },
        setAllUsers(state, value) {
            state.allUsers = value.payload;
        },
        setAllPrivilegedUsers(state, value) {
            state.allPrivilegedUsers = value.payload;
        },
        setLoading(state, value) {
            state.loading = value.payload;
        },
        setToken(state, value) {
            state.token = value.payload;
        },
        setIsProd(state, value) {
            state.isProd = value.payload;
        },
    },
});

export const { setSignInData, setLoading, setToken, setAllUsers, setIsProd, setAllPrivilegedUsers } = authSlice.actions;

export default authSlice.reducer;
